import { render, staticRenderFns } from "./upload-images.vue?vue&type=template&id=3ffc5f44&"
import script from "./upload-images.vue?vue&type=script&lang=ts&"
export * from "./upload-images.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports